import{_}from"./_root.js";var r=_["__core-js_shared__"];export{r as _};
